export const DADOS_EDITOR_RTF = 'DADOS_EDITOR_RTF';
export const editorRtf = (textRtf) => ({
  type: DADOS_EDITOR_RTF,
  payload: {
    textRtf,
  },
});

export const ID_RTF = 'ID_RTF';
export const idRtf = (idRtf) => ({
  type: ID_RTF,
  payload: {
    idRtf,
  },
});
export const DADOS_EDITOR_PLAIN_TEXT = 'DADOS_EDITOR_PLAIN_TEXT';
export const editorPlainText = (plainText) => ({
  type: DADOS_EDITOR_PLAIN_TEXT,
  payload: {
    plainText,
  },
});

export const EDITOR_READONLY = 'EDITOR_READONLY';
export const editorReadOnly = (ReadOnly) => ({
  type: EDITOR_READONLY,
  payload: {
    editorReadOnly: ReadOnly,
  },
});

export const CHANGE_MED_EXECUTANTE = 'CHANGE_MED_EXECUTANTE';
export const ChangeMedExecutante = (medExecutante) => ({
  type: CHANGE_MED_EXECUTANTE,
  payload: {
    medExecutante,
  },
});

export const CHANGE_MED_REVISOR = 'CHANGE_MED_REVISOR';
export const ChangeMedRevisor = (medRevisor) => ({
  type: CHANGE_MED_REVISOR,
  payload: {
    medRevisor,
  },
});

export const CHANGE_STATUS = 'CHANGE_STATUS';
export const ChangeStatus = (status) => ({
  type: CHANGE_STATUS,
  payload: {
    status,
  },
});

export const ATUALIZAR_AVISO = 'ATUALIZAR_AVISO';
export const atualizarAviso = (mensagem, tipo) => ({
  type: ATUALIZAR_AVISO,
  payload: {
    mensagem,
    tipo,
  },
});

export const DADOS_EDITOR_HEADER_FOOTER = 'DADOS_EDITOR_HEADER_FOOTER';
export const editorHeaderFooter = (headerFooterRtf) => ({
  type: DADOS_EDITOR_HEADER_FOOTER,
  payload: {
    headerFooterRtf,
  },
});



// WEBPACK FOOTER //
// ./src/pages/laudo/editor/editor.action.js